import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/anime';

const categoryIcons: Record<string, string> = {
  all: 'ri-global-line',
  japanese: 'ri-sun-line',
  chinese: 'ri-china-railway-line',
  movie: 'ri-film-line',
  action: 'ri-fire-line',
  comedy: 'ri-emotion-laugh-line',
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
};

const categoryBgColors: Record<string, string> = {
  all: 'bg-accent-100',
  japanese: 'bg-primary-100',
  chinese: 'bg-secondary-100',
  movie: 'bg-accent-100',
  action: 'bg-primary-100',
  comedy: 'bg-secondary-100',
  romance: 'bg-accent-100',
  fantasy: 'bg-primary-100',
};

const categoryIconColors: Record<string, string> = {
  all: 'text-accent-600',
  japanese: 'text-primary-600',
  chinese: 'text-secondary-600',
  movie: 'text-accent-600',
  action: 'text-primary-600',
  comedy: 'text-secondary-600',
  romance: 'text-accent-600',
  fantasy: 'text-primary-600',
};

export default function CategorySection() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/category/${slug}`);
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            番剧分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型发现你喜欢的动漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.slug)}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg ${categoryBgColors[cat.slug] || 'bg-primary-100'} transition-transform group-hover:scale-110`}>
                <i className={`${categoryIcons[cat.slug] || 'ri-apps-line'} text-xl md:text-2xl ${categoryIconColors[cat.slug] || 'text-primary-600'}`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}